// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
    background: #ffffff;
}

.about-content-section {
    padding-top: 64px;
    padding-bottom: 20px;
}

.about-page .about-content-section:last-of-type {
    padding-bottom: 8px;
}

.about-hero-section {
    position: relative;
    overflow: hidden;
    background: #0d0d10;
    color: #ffffff;
    min-height: 64vh;
    display: flex;
    align-items: center;
}

.about-hero-background {
    position: absolute;
    inset: 0;
}

.about-grid-lines {
    position: absolute;
    inset: -30%;
    background-image:
        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);
    background-size: 48px 48px;
    transform: perspective(700px) rotateX(62deg);
    animation: aboutGridDrift 24s linear infinite;
}

.about-radial-glow {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 20% 25%, rgba(217, 0, 27, 0.2), transparent 26%),
        radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.08), transparent 20%);
}

.about-hero-layout {
    position: relative;
    z-index: 1;
    display: block;
    padding-top: 124px;
    padding-bottom: 76px;
}

.about-hero-copy {
    max-width: 880px;
}

.about-kicker,
.about-mini-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.about-hero-brand {
    display: flex;
    align-items: center;
    gap: 22px;
    margin: 20px 0 28px;
}

.about-page-logo {
    width: 74px;
    height: 74px;
    object-fit: contain;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.95);
    padding: 10px;
}

.about-hero-title {
    font-size: clamp(2.8rem, 6vw, 4.8rem);
    line-height: 1;
    margin: 0 0 8px;
}

.about-hero-subtitle {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.72);
    letter-spacing: 0.08em;
}

.about-hero-text {
    max-width: 700px;
    font-size: 1.08rem;
    line-height: 1.9;
    color: rgba(255, 255, 255, 0.9);
}

.about-greeting-visual {
    display: flex;
    justify-content: center;
}

.about-image-placeholder,
.about-real-image {
    width: 100%;
    height: 100%;
    min-height: 320px;
    border-radius: 28px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
}

.about-image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px;
    color: rgba(0, 0, 0, 0.42);
    background:
        linear-gradient(135deg, #ececec 0%, #d9d9d9 50%, #efefef 100%);
    background-size: 200% 200%;
    animation: gradientMove 3s ease infinite;
}

.president-image-placeholder {
    min-height: 100%;
}

.about-real-image {
    object-fit: cover;
    display: block;
}

.about-company-grid,
.about-philosophy-grid,
.about-greeting-layout,
.about-mvv-grid {
    display: grid;
    gap: 20px;
}

.about-mvv-grid {
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
    align-items: stretch;
}

.about-greeting-layout {
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
}

.about-side-stack {
    display: grid;
    gap: 24px;
}

.about-company-panel,
.about-philosophy-main,
.about-solve-card,
.about-panel,
.about-greeting-card,
.about-contact-card {
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid var(--border-color);
    border-radius: 24px;
    padding: 24px;
    box-shadow: var(--shadow-sm);
}

.about-info-card h3,
.about-panel h2 {
    font-size: 1.45rem;
    margin-bottom: 12px;
}

.about-company-panel p,
.about-philosophy-intro,
.about-solve-card p,
.about-panel p,
.about-greeting-card p {
    color: var(--text-light);
    line-height: 1.9;
}

.about-business-list,
.about-bullet-list,
.about-values-list {
    display: grid;
}

.about-business-list,
.about-bullet-list,
.about-values-list {
    gap: 10px;
}

.about-company-panel {
    display: grid;
    gap: 24px;
}

.about-company-intro {
    display: grid;
    grid-template-columns: minmax(240px, 0.5fr) minmax(0, 1fr);
    gap: 24px;
    align-items: start;
}

.about-company-heading h3 {
    font-size: 2rem;
    line-height: 1.1;
    margin: 10px 0 8px;
}

.about-company-heading p {
    color: var(--text-main);
    font-weight: 600;
    letter-spacing: 0.06em;
}

.about-company-description {
    position: relative;
    padding-left: 24px;
}

.about-company-description::before {
    content: '';
    position: absolute;
    left: 0;
    top: 4px;
    width: 4px;
    height: calc(100% - 8px);
    border-radius: 999px;
    background: linear-gradient(180deg, var(--accent-red) 0%, rgba(217, 0, 27, 0.18) 100%);
}

.about-company-business {
    display: grid;
    gap: 14px;
    padding-top: 4px;
    border-top: 1px solid var(--border-color);
}

.about-strengths-layout {
    display: grid;
    grid-template-columns: minmax(320px, 0.92fr) minmax(0, 1.08fr);
    gap: 20px;
    align-items: stretch;
}

.about-strengths-main,
.about-team-panel {
    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);
    border: 1px solid var(--border-color);
    border-radius: 24px;
    padding: 28px;
    box-shadow: var(--shadow-sm);
}

.about-strengths-main {
    display: flex;
    flex-direction: column;
}

.about-strengths-main h3,
.about-team-panel h3 {
    font-size: 1.8rem;
    line-height: 1.2;
    color: var(--text-main);
    margin: 12px 0 14px;
}

.about-strengths-main p {
    color: var(--text-light);
    line-height: 1.9;
}

.about-strengths-stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-top: 28px;
    flex: 1;
}

.about-stat-card {
    display: grid;
    gap: 10px;
    min-height: 0;
    height: 100%;
    align-content: end;
    padding: 20px;
    border-radius: 20px;
    border: 1px solid rgba(217, 0, 27, 0.12);
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(255, 245, 245, 0.98) 100%);
}

.about-stat-card strong {
    font-size: clamp(2rem, 4vw, 3rem);
    line-height: 1;
    color: var(--accent-red);
}

.about-stat-card span {
    color: var(--text-main);
    font-weight: 700;
    line-height: 1.5;
}

.about-team-panel {
    display: grid;
    gap: 22px;
}

.about-team-panel-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.about-team-panel-header p {
    color: var(--text-light);
}

.about-team-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 14px;
    border-radius: 999px;
    background: #fff3f4;
    border: 1px solid rgba(217, 0, 27, 0.12);
    color: var(--accent-red);
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1;
}

.about-team-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 18px 16px;
}

.about-team-member {
    display: grid;
    justify-items: center;
    gap: 12px;
    text-align: center;
}

.about-team-avatar {
    width: 100%;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 22px;
    border: 1px solid rgba(217, 0, 27, 0.12);
    background:
        radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.96), transparent 35%),
        linear-gradient(135deg, #ffffff 0%, #fbfbfb 48%, #f3f3f3 100%);
    box-shadow: 0 14px 30px rgba(217, 0, 27, 0.08);
}

.about-team-avatar span {
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 800;
    color: #8c1222;
}

.about-team-panel:hover .about-team-cta {
    background: var(--accent-red);
    color: #ffffff;
}

.about-team-avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
    display: block;
}

.about-team-name {
    color: var(--text-main);
    font-size: 0.92rem;
    font-weight: 700;
    line-height: 1.45;
}

.about-business-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 18px;
    border: 1px solid var(--border-color);
    border-radius: 18px;
    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);
}

.about-business-index,
.about-solve-key {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--accent-red);
    font-weight: 800;
}

.about-business-index {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(217, 0, 27, 0.08);
    font-size: 0.85rem;
    flex-shrink: 0;
}

.about-business-list {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 14px;
}

.about-business-item p {
    color: var(--text-main);
    font-size: 0.95rem;
    line-height: 1.6;
    font-weight: 600;
}

.about-philosophy-layout {
    display: grid;
    grid-template-columns: minmax(300px, 0.82fr) minmax(0, 1.18fr);
    gap: 20px;
    align-items: start;
}

.about-philosophy-main {
    position: sticky;
    top: 110px;
}

.about-philosophy-headline {
    font-size: 1.7rem;
    font-weight: 800;
    line-height: 1.25;
    color: var(--text-main);
    margin-top: 10px;
}

.about-philosophy-formula {
    margin: 10px 0 14px;
    font-size: 1.02rem;
    font-weight: 700;
    color: var(--accent-red);
}

.about-solve-rail {
    display: grid;
    gap: 12px;
}

.about-solve-card {
    display: grid;
    grid-template-columns: 88px 1fr;
    gap: 16px;
    align-items: stretch;
}

.about-solve-key {
    width: 100%;
    min-height: 100%;
    border-radius: 18px;
    background: linear-gradient(180deg, #fff1f2 0%, #ffe5e8 100%);
    margin-bottom: 0;
    font-size: 2.3rem;
    font-weight: 900;
    letter-spacing: 0.02em;
    align-self: stretch;
}

html:lang(ja) .about-solve-key {
    font-weight: 700;
}

.about-solve-card h3 {
    font-size: 1rem;
    margin-bottom: 8px;
    line-height: 1.45;
}

.about-philosophy-intro,
.about-solve-card p {
    font-size: 0.95rem;
    line-height: 1.75;
}

.about-panel-quote {
    font-size: 1.2rem;
    font-weight: 700;
    color: var(--text-main) !important;
    margin-bottom: 18px;
}

.about-bullet-list p,
.about-greeting-card p {
    position: relative;
    padding-left: 18px;
}

.about-bullet-list p::before,
.about-greeting-card p::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.9em;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--accent-red);
    transform: translateY(-50%);
}

.about-values-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.about-value-pill {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-height: 54px;
    padding: 12px 16px;
    border-radius: 999px;
    background: #fff5f5;
    color: var(--accent-red);
    font-weight: 700;
    text-align: center;
}

.about-greeting-card {
    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);
}

.about-greeting-card p + p {
    margin-top: 18px;
}

.about-contact-card {
    display: grid;
    gap: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);
}

.about-contact-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
}

.about-contact-item {
    padding: 18px;
    border: 1px solid var(--border-color);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.9);
}

.about-contact-item p {
    margin-top: 10px;
    color: var(--text-main);
    line-height: 1.8;
    word-break: break-word;
}

.about-contact-copyright {
    padding-top: 18px;
    border-top: 1px solid var(--border-color);
    color: var(--text-light);
    font-size: 0.92rem;
}

@keyframes aboutGridDrift {
    from {
        transform: perspective(700px) rotateX(62deg) translateY(0);
    }

    to {
        transform: perspective(700px) rotateX(62deg) translateY(48px);
    }
}

@media (max-width: 992px) {
    .about-hero-layout,
    .about-greeting-layout,
    .about-mvv-grid,
    .about-philosophy-layout,
    .about-company-intro,
    .about-strengths-layout {
        grid-template-columns: 1fr;
    }

    .about-values-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .about-business-list,
    .about-contact-grid,
    .about-team-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .about-philosophy-main {
        position: static;
    }
}

@media (max-width: 768px) {
    .about-content-section {
        padding-top: 48px;
    }

    .about-hero-section {
        min-height: 56vh;
    }

    .about-hero-layout {
        padding-top: 108px;
        padding-bottom: 56px;
        gap: 28px;
    }

    .about-hero-brand {
        flex-direction: column;
        align-items: flex-start;
    }

    .about-info-card,
    .about-business-card,
    .about-philosophy-main,
    .about-solve-card,
    .about-panel,
    .about-greeting-card {
        padding: 22px;
        border-radius: 18px;
    }

    .about-business-list,
    .about-contact-grid,
    .about-values-list,
    .about-strengths-stats {
        grid-template-columns: 1fr;
    }

    .about-team-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px 12px;
    }

    .about-team-member {
        gap: 8px;
    }

    .about-team-avatar {
        max-width: 120px;
        border-radius: 18px;
        box-shadow: 0 10px 20px rgba(217, 0, 27, 0.08);
    }

    .about-team-name {
        font-size: 0.84rem;
        line-height: 1.35;
    }

    .about-business-item {
        padding: 14px 16px;
    }

    .about-panel-quote {
        font-size: 1.05rem;
    }

    .about-company-description {
        padding-left: 16px;
    }

    .about-strengths-main,
    .about-team-panel {
        padding: 22px;
        border-radius: 18px;
    }

    .about-strengths-main h3,
    .about-team-panel h3 {
        font-size: 1.45rem;
    }

    .about-solve-card {
        grid-template-columns: 64px 1fr;
        gap: 12px;
    }

    .about-solve-key {
        font-size: 1.6rem;
        border-radius: 14px;
    }
}

@media (max-width: 480px) {
    .about-strengths-main,
    .about-team-panel {
        padding: 18px;
    }

    .about-team-grid {
        gap: 12px 10px;
    }

    .about-team-avatar {
        max-width: 96px;
        border-radius: 16px;
    }

    .about-team-name {
        font-size: 0.78rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/about.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;+EAE2E;IAC3E,0BAA0B;IAC1B,4CAA4C;IAC5C,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;sFAEkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,0BAA0B;IAC1B;sEACkE;IAClE,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;;;IAII,aAAa;IACb,SAAS;AACb;;AAEA;IACI,0DAA0D;IAC1D,oBAAoB;AACxB;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;;;;;IAMI,qCAAqC;IACrC,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,4BAA4B;AAChC;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;;;IAKI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0DAA0D;IAC1D,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,sFAAsF;AAC1F;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8DAA8D;IAC9D,SAAS;IACT,oBAAoB;AACxB;;AAEA;;IAEI,6DAA6D;IAC7D,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,6CAA6C;IAC7C,SAAS;IACT,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC;6FACyF;AAC7F;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,wCAAwC;IACxC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC;;sEAEkE;IAClE,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,6DAA6D;AACjE;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8DAA8D;IAC9D,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,6DAA6D;IAC7D,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,6DAA6D;AACjE;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI;QACI,0DAA0D;IAC9D;;IAEA;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI;;;;;;QAMI,0BAA0B;IAC9B;;IAEA;QACI,gDAAgD;IACpD;;IAEA;;;QAGI,gDAAgD;IACpD;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;;;;;;QAMI,aAAa;QACb,mBAAmB;IACvB;;IAEA;;;;QAII,0BAA0B;IAC9B;;IAEA;QACI,gDAAgD;QAChD,cAAc;IAClB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,8CAA8C;IAClD;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;QACb,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;QAC/B,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;;QAEI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".about-page {\r\n    background: #ffffff;\r\n}\r\n\r\n.about-content-section {\r\n    padding-top: 64px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.about-page .about-content-section:last-of-type {\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.about-hero-section {\r\n    position: relative;\r\n    overflow: hidden;\r\n    background: #0d0d10;\r\n    color: #ffffff;\r\n    min-height: 64vh;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.about-hero-background {\r\n    position: absolute;\r\n    inset: 0;\r\n}\r\n\r\n.about-grid-lines {\r\n    position: absolute;\r\n    inset: -30%;\r\n    background-image:\r\n        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),\r\n        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);\r\n    background-size: 48px 48px;\r\n    transform: perspective(700px) rotateX(62deg);\r\n    animation: aboutGridDrift 24s linear infinite;\r\n}\r\n\r\n.about-radial-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        radial-gradient(circle at 20% 25%, rgba(217, 0, 27, 0.2), transparent 26%),\r\n        radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.08), transparent 20%);\r\n}\r\n\r\n.about-hero-layout {\r\n    position: relative;\r\n    z-index: 1;\r\n    display: block;\r\n    padding-top: 124px;\r\n    padding-bottom: 76px;\r\n}\r\n\r\n.about-hero-copy {\r\n    max-width: 880px;\r\n}\r\n\r\n.about-kicker,\r\n.about-mini-label {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.about-hero-brand {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 22px;\r\n    margin: 20px 0 28px;\r\n}\r\n\r\n.about-page-logo {\r\n    width: 74px;\r\n    height: 74px;\r\n    object-fit: contain;\r\n    border-radius: 16px;\r\n    background: rgba(255, 255, 255, 0.95);\r\n    padding: 10px;\r\n}\r\n\r\n.about-hero-title {\r\n    font-size: clamp(2.8rem, 6vw, 4.8rem);\r\n    line-height: 1;\r\n    margin: 0 0 8px;\r\n}\r\n\r\n.about-hero-subtitle {\r\n    font-size: 1rem;\r\n    color: rgba(255, 255, 255, 0.72);\r\n    letter-spacing: 0.08em;\r\n}\r\n\r\n.about-hero-text {\r\n    max-width: 700px;\r\n    font-size: 1.08rem;\r\n    line-height: 1.9;\r\n    color: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.about-greeting-visual {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.about-image-placeholder,\r\n.about-real-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    min-height: 320px;\r\n    border-radius: 28px;\r\n    border: 1px solid rgba(255, 255, 255, 0.14);\r\n    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.about-image-placeholder {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    padding: 24px;\r\n    color: rgba(0, 0, 0, 0.42);\r\n    background:\r\n        linear-gradient(135deg, #ececec 0%, #d9d9d9 50%, #efefef 100%);\r\n    background-size: 200% 200%;\r\n    animation: gradientMove 3s ease infinite;\r\n}\r\n\r\n.president-image-placeholder {\r\n    min-height: 100%;\r\n}\r\n\r\n.about-real-image {\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n\r\n.about-company-grid,\r\n.about-philosophy-grid,\r\n.about-greeting-layout,\r\n.about-mvv-grid {\r\n    display: grid;\r\n    gap: 20px;\r\n}\r\n\r\n.about-mvv-grid {\r\n    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);\r\n    align-items: stretch;\r\n}\r\n\r\n.about-greeting-layout {\r\n    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);\r\n}\r\n\r\n.about-side-stack {\r\n    display: grid;\r\n    gap: 24px;\r\n}\r\n\r\n.about-company-panel,\r\n.about-philosophy-main,\r\n.about-solve-card,\r\n.about-panel,\r\n.about-greeting-card,\r\n.about-contact-card {\r\n    background: rgba(255, 255, 255, 0.92);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 24px;\r\n    padding: 24px;\r\n    box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.about-info-card h3,\r\n.about-panel h2 {\r\n    font-size: 1.45rem;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.about-company-panel p,\r\n.about-philosophy-intro,\r\n.about-solve-card p,\r\n.about-panel p,\r\n.about-greeting-card p {\r\n    color: var(--text-light);\r\n    line-height: 1.9;\r\n}\r\n\r\n.about-business-list,\r\n.about-bullet-list,\r\n.about-values-list {\r\n    display: grid;\r\n}\r\n\r\n.about-business-list,\r\n.about-bullet-list,\r\n.about-values-list {\r\n    gap: 10px;\r\n}\r\n\r\n.about-company-panel {\r\n    display: grid;\r\n    gap: 24px;\r\n}\r\n\r\n.about-company-intro {\r\n    display: grid;\r\n    grid-template-columns: minmax(240px, 0.5fr) minmax(0, 1fr);\r\n    gap: 24px;\r\n    align-items: start;\r\n}\r\n\r\n.about-company-heading h3 {\r\n    font-size: 2rem;\r\n    line-height: 1.1;\r\n    margin: 10px 0 8px;\r\n}\r\n\r\n.about-company-heading p {\r\n    color: var(--text-main);\r\n    font-weight: 600;\r\n    letter-spacing: 0.06em;\r\n}\r\n\r\n.about-company-description {\r\n    position: relative;\r\n    padding-left: 24px;\r\n}\r\n\r\n.about-company-description::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 4px;\r\n    width: 4px;\r\n    height: calc(100% - 8px);\r\n    border-radius: 999px;\r\n    background: linear-gradient(180deg, var(--accent-red) 0%, rgba(217, 0, 27, 0.18) 100%);\r\n}\r\n\r\n.about-company-business {\r\n    display: grid;\r\n    gap: 14px;\r\n    padding-top: 4px;\r\n    border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.about-strengths-layout {\r\n    display: grid;\r\n    grid-template-columns: minmax(320px, 0.92fr) minmax(0, 1.08fr);\r\n    gap: 20px;\r\n    align-items: stretch;\r\n}\r\n\r\n.about-strengths-main,\r\n.about-team-panel {\r\n    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 24px;\r\n    padding: 28px;\r\n    box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.about-strengths-main {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.about-strengths-main h3,\r\n.about-team-panel h3 {\r\n    font-size: 1.8rem;\r\n    line-height: 1.2;\r\n    color: var(--text-main);\r\n    margin: 12px 0 14px;\r\n}\r\n\r\n.about-strengths-main p {\r\n    color: var(--text-light);\r\n    line-height: 1.9;\r\n}\r\n\r\n.about-strengths-stats {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    grid-template-rows: repeat(2, minmax(0, 1fr));\r\n    gap: 14px;\r\n    margin-top: 28px;\r\n    flex: 1;\r\n}\r\n\r\n.about-stat-card {\r\n    display: grid;\r\n    gap: 10px;\r\n    min-height: 0;\r\n    height: 100%;\r\n    align-content: end;\r\n    padding: 20px;\r\n    border-radius: 20px;\r\n    border: 1px solid rgba(217, 0, 27, 0.12);\r\n    background:\r\n        linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(255, 245, 245, 0.98) 100%);\r\n}\r\n\r\n.about-stat-card strong {\r\n    font-size: clamp(2rem, 4vw, 3rem);\r\n    line-height: 1;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.about-stat-card span {\r\n    color: var(--text-main);\r\n    font-weight: 700;\r\n    line-height: 1.5;\r\n}\r\n\r\n.about-team-panel {\r\n    display: grid;\r\n    gap: 22px;\r\n}\r\n\r\n.about-team-panel-header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n}\r\n\r\n.about-team-panel-header p {\r\n    color: var(--text-light);\r\n}\r\n\r\n.about-team-cta {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 14px;\r\n    border-radius: 999px;\r\n    background: #fff3f4;\r\n    border: 1px solid rgba(217, 0, 27, 0.12);\r\n    color: var(--accent-red);\r\n    font-size: 0.82rem;\r\n    font-weight: 700;\r\n    line-height: 1;\r\n}\r\n\r\n.about-team-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(0, 1fr));\r\n    gap: 18px 16px;\r\n}\r\n\r\n.about-team-member {\r\n    display: grid;\r\n    justify-items: center;\r\n    gap: 12px;\r\n    text-align: center;\r\n}\r\n\r\n.about-team-avatar {\r\n    width: 100%;\r\n    aspect-ratio: 1 / 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 22px;\r\n    border: 1px solid rgba(217, 0, 27, 0.12);\r\n    background:\r\n        radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.96), transparent 35%),\r\n        linear-gradient(135deg, #ffffff 0%, #fbfbfb 48%, #f3f3f3 100%);\r\n    box-shadow: 0 14px 30px rgba(217, 0, 27, 0.08);\r\n}\r\n\r\n.about-team-avatar span {\r\n    font-size: clamp(1.5rem, 3vw, 2rem);\r\n    font-weight: 800;\r\n    color: #8c1222;\r\n}\r\n\r\n.about-team-panel:hover .about-team-cta {\r\n    background: var(--accent-red);\r\n    color: #ffffff;\r\n}\r\n\r\n.about-team-avatar-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border-radius: inherit;\r\n    display: block;\r\n}\r\n\r\n.about-team-name {\r\n    color: var(--text-main);\r\n    font-size: 0.92rem;\r\n    font-weight: 700;\r\n    line-height: 1.45;\r\n}\r\n\r\n.about-business-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    padding: 16px 18px;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 18px;\r\n    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);\r\n}\r\n\r\n.about-business-index,\r\n.about-solve-key {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--accent-red);\r\n    font-weight: 800;\r\n}\r\n\r\n.about-business-index {\r\n    width: 38px;\r\n    height: 38px;\r\n    border-radius: 50%;\r\n    background: rgba(217, 0, 27, 0.08);\r\n    font-size: 0.85rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.about-business-list {\r\n    grid-template-columns: repeat(5, minmax(0, 1fr));\r\n    gap: 14px;\r\n}\r\n\r\n.about-business-item p {\r\n    color: var(--text-main);\r\n    font-size: 0.95rem;\r\n    line-height: 1.6;\r\n    font-weight: 600;\r\n}\r\n\r\n.about-philosophy-layout {\r\n    display: grid;\r\n    grid-template-columns: minmax(300px, 0.82fr) minmax(0, 1.18fr);\r\n    gap: 20px;\r\n    align-items: start;\r\n}\r\n\r\n.about-philosophy-main {\r\n    position: sticky;\r\n    top: 110px;\r\n}\r\n\r\n.about-philosophy-headline {\r\n    font-size: 1.7rem;\r\n    font-weight: 800;\r\n    line-height: 1.25;\r\n    color: var(--text-main);\r\n    margin-top: 10px;\r\n}\r\n\r\n.about-philosophy-formula {\r\n    margin: 10px 0 14px;\r\n    font-size: 1.02rem;\r\n    font-weight: 700;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.about-solve-rail {\r\n    display: grid;\r\n    gap: 12px;\r\n}\r\n\r\n.about-solve-card {\r\n    display: grid;\r\n    grid-template-columns: 88px 1fr;\r\n    gap: 16px;\r\n    align-items: stretch;\r\n}\r\n\r\n.about-solve-key {\r\n    width: 100%;\r\n    min-height: 100%;\r\n    border-radius: 18px;\r\n    background: linear-gradient(180deg, #fff1f2 0%, #ffe5e8 100%);\r\n    margin-bottom: 0;\r\n    font-size: 2.3rem;\r\n    font-weight: 900;\r\n    letter-spacing: 0.02em;\r\n    align-self: stretch;\r\n}\r\n\r\nhtml:lang(ja) .about-solve-key {\r\n    font-weight: 700;\r\n}\r\n\r\n.about-solve-card h3 {\r\n    font-size: 1rem;\r\n    margin-bottom: 8px;\r\n    line-height: 1.45;\r\n}\r\n\r\n.about-philosophy-intro,\r\n.about-solve-card p {\r\n    font-size: 0.95rem;\r\n    line-height: 1.75;\r\n}\r\n\r\n.about-panel-quote {\r\n    font-size: 1.2rem;\r\n    font-weight: 700;\r\n    color: var(--text-main) !important;\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.about-bullet-list p,\r\n.about-greeting-card p {\r\n    position: relative;\r\n    padding-left: 18px;\r\n}\r\n\r\n.about-bullet-list p::before,\r\n.about-greeting-card p::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0.9em;\r\n    width: 7px;\r\n    height: 7px;\r\n    border-radius: 50%;\r\n    background: var(--accent-red);\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.about-values-list {\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n}\r\n\r\n.about-value-pill {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 54px;\r\n    padding: 12px 16px;\r\n    border-radius: 999px;\r\n    background: #fff5f5;\r\n    color: var(--accent-red);\r\n    font-weight: 700;\r\n    text-align: center;\r\n}\r\n\r\n.about-greeting-card {\r\n    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);\r\n}\r\n\r\n.about-greeting-card p + p {\r\n    margin-top: 18px;\r\n}\r\n\r\n.about-contact-card {\r\n    display: grid;\r\n    gap: 24px;\r\n    background: linear-gradient(180deg, #ffffff 0%, #faf7f7 100%);\r\n}\r\n\r\n.about-contact-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(0, 1fr));\r\n    gap: 16px;\r\n}\r\n\r\n.about-contact-item {\r\n    padding: 18px;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 18px;\r\n    background: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.about-contact-item p {\r\n    margin-top: 10px;\r\n    color: var(--text-main);\r\n    line-height: 1.8;\r\n    word-break: break-word;\r\n}\r\n\r\n.about-contact-copyright {\r\n    padding-top: 18px;\r\n    border-top: 1px solid var(--border-color);\r\n    color: var(--text-light);\r\n    font-size: 0.92rem;\r\n}\r\n\r\n@keyframes aboutGridDrift {\r\n    from {\r\n        transform: perspective(700px) rotateX(62deg) translateY(0);\r\n    }\r\n\r\n    to {\r\n        transform: perspective(700px) rotateX(62deg) translateY(48px);\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .about-hero-layout,\r\n    .about-greeting-layout,\r\n    .about-mvv-grid,\r\n    .about-philosophy-layout,\r\n    .about-company-intro,\r\n    .about-strengths-layout {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .about-values-list {\r\n        grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    }\r\n\r\n    .about-business-list,\r\n    .about-contact-grid,\r\n    .about-team-grid {\r\n        grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    }\r\n\r\n    .about-philosophy-main {\r\n        position: static;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .about-content-section {\r\n        padding-top: 48px;\r\n    }\r\n\r\n    .about-hero-section {\r\n        min-height: 56vh;\r\n    }\r\n\r\n    .about-hero-layout {\r\n        padding-top: 108px;\r\n        padding-bottom: 56px;\r\n        gap: 28px;\r\n    }\r\n\r\n    .about-hero-brand {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .about-info-card,\r\n    .about-business-card,\r\n    .about-philosophy-main,\r\n    .about-solve-card,\r\n    .about-panel,\r\n    .about-greeting-card {\r\n        padding: 22px;\r\n        border-radius: 18px;\r\n    }\r\n\r\n    .about-business-list,\r\n    .about-contact-grid,\r\n    .about-values-list,\r\n    .about-strengths-stats {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .about-team-grid {\r\n        grid-template-columns: repeat(2, minmax(0, 1fr));\r\n        gap: 14px 12px;\r\n    }\r\n\r\n    .about-team-member {\r\n        gap: 8px;\r\n    }\r\n\r\n    .about-team-avatar {\r\n        max-width: 120px;\r\n        border-radius: 18px;\r\n        box-shadow: 0 10px 20px rgba(217, 0, 27, 0.08);\r\n    }\r\n\r\n    .about-team-name {\r\n        font-size: 0.84rem;\r\n        line-height: 1.35;\r\n    }\r\n\r\n    .about-business-item {\r\n        padding: 14px 16px;\r\n    }\r\n\r\n    .about-panel-quote {\r\n        font-size: 1.05rem;\r\n    }\r\n\r\n    .about-company-description {\r\n        padding-left: 16px;\r\n    }\r\n\r\n    .about-strengths-main,\r\n    .about-team-panel {\r\n        padding: 22px;\r\n        border-radius: 18px;\r\n    }\r\n\r\n    .about-strengths-main h3,\r\n    .about-team-panel h3 {\r\n        font-size: 1.45rem;\r\n    }\r\n\r\n    .about-solve-card {\r\n        grid-template-columns: 64px 1fr;\r\n        gap: 12px;\r\n    }\r\n\r\n    .about-solve-key {\r\n        font-size: 1.6rem;\r\n        border-radius: 14px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .about-strengths-main,\r\n    .about-team-panel {\r\n        padding: 18px;\r\n    }\r\n\r\n    .about-team-grid {\r\n        gap: 12px 10px;\r\n    }\r\n\r\n    .about-team-avatar {\r\n        max-width: 96px;\r\n        border-radius: 16px;\r\n    }\r\n\r\n    .about-team-name {\r\n        font-size: 0.78rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
